module.exports = __webpack_public_path__ + "static/media/snow.f7ecc7f9.webp";